import Supplies from "./Supplies";

export default {
    Supplies
};
